import React from 'react';
import {Alert, Button} from 'react-bootstrap';
import uniqBy = require("lodash/uniqBy");
import {ValidationMessage} from "core/common/domain/commonDomain";

import "core/components/errorComp/errorComp.less";

interface ErrorCompProps {
  messages: ValidationMessage[];
  style?: any;
  onDismiss?: Function;
  header?: any;
  bsStyle?: string;
  className?: string;
  dismissLabel?: string;
}

export function ErrorComp({messages, style, onDismiss, header, bsStyle, className, dismissLabel}: ErrorCompProps) {
  if (!bsStyle) bsStyle = 'danger';
  if (!className) className = 'error-comp';

  return (messages && messages.length) ? (
    <Alert bsStyle={bsStyle} className={className} style={style} onDismiss={onDismiss}>
      {(header) ? <h4>{header}</h4> : null}
      <ul>
        {
          uniqBy<ValidationMessage>(messages, v => v.propertyPath + v.message).map( (m,i) => {
            return (
              <li key={i}> { ((m.propertyPath) ? ('Field ' + m.propertyPath + ' : ') : '') + m.message} </li>
            );
          })
        }
      </ul>
      {(dismissLabel) ? <Button onClick={onDismiss}>{dismissLabel}</Button> : null}
    </Alert>
  ) : <noscript/> ;
}



// WEBPACK FOOTER //
// ./src/core/components/errorComp/errorComp.tsx